export type ErrorNotificationItem = {
  id: number
  original: unknown
}

type StoreData = {
  errors: ErrorNotificationItem[]
}

type Listener = (data: StoreData) => void

class Store {
  private data: StoreData = {
    errors: [],
  }
  private listeners: Set<Listener> = new Set()

  set<K extends keyof StoreData>(key: K, value: StoreData[K]): void {
    this.data[key] = value
    this.notify()
  }

  get<K extends keyof StoreData>(key: K): StoreData[K] | undefined {
    return this.data[key]
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }

  private notify(): void {
    for (const listener of this.listeners) {
      listener(this.data)
    }
  }
}

export const errors_store = new Store()

export const addErrorToModal = (error: ErrorNotificationItem) => {
  return errors_store.set('errors', [...errors_store.get('errors')!, error])
}

export const removeErrorFromList = (id: number) => {
  return errors_store.set(
    'errors',
    errors_store.get('errors')?.filter((v) => v.id !== id) ?? [],
  )
}
